import { OrgUnitContact, OrgUnitLocation, OrgUnitsDataActions } from '@msdyn365-commerce/retail-proxy';
import { useEffect, useState } from 'react';
import { IHeiStoreContactData } from './hei-store-contact.data';
import { IHeiStoreContactProps } from './hei-store-contact.props.autogenerated';

export type IHeiStoreContactViewProps = IHeiStoreContactProps<IHeiStoreContactData> & {
    phoneNumber: string;
    emailAddress: string;
};

const HeiStoreContact = (props: IHeiStoreContactProps<IHeiStoreContactData>) => {
    const {
        context,
        config: { orgUnitNumber }
    } = props;

    const [orgUnitLocation, setOrgUnitLocation] = useState<OrgUnitLocation>();
    const [storeInfoLoaded, setStoreInfoLoaded] = useState(false);

    useEffect(() => {
        const ctx = { callerContext: context.actionContext };

        if (storeInfoLoaded) {
            return;
        }

        setStoreInfoLoaded(true);

        void (async () => {
            try {
                const allStores = await OrgUnitsDataActions.searchOrgUnitLocationsAsync(ctx, {
                    OrgUnitNumber: orgUnitNumber
                });

                const store = allStores?.find(s => s.OrgUnitNumber === orgUnitNumber);

                if (store) {
                    setOrgUnitLocation(store);
                }
            } catch (error) {
                context.telemetry.exception(error as Error);
            }
        })();
    }, [orgUnitNumber]);

    if (!orgUnitLocation) {
        return null;
    }

    const [phoneNumber, emailAddress] = extractContacts(orgUnitLocation.Contacts);

    return props.renderView({
        ...props,
        phoneNumber,
        emailAddress
    });
};

const extractContacts = (contacts: OrgUnitContact[] | undefined) => {
    if (!contacts) {
        return ['', ''];
    }

    const allPhoneContacts = contacts.filter(contact => contact.ContactTypeValue === 1 && !contact.IsPrivate);
    const allEmailPhoneContacts = contacts.filter(contact => contact.ContactTypeValue === 2 && !contact.IsPrivate);

    let phoneContact = '';
    if (allPhoneContacts && allPhoneContacts.length > 0) {
        const primaryPhoneContact = allPhoneContacts.find(contact => contact.IsPrimary);

        if (primaryPhoneContact) {
            phoneContact = primaryPhoneContact.Locator || '';
        }

        if (!phoneContact) {
            phoneContact = allPhoneContacts[0].Locator || '';
        }
    }

    let emailContact = '';
    if (allEmailPhoneContacts && allEmailPhoneContacts.length > 0) {
        const primaryEmailContact = allEmailPhoneContacts.find(contact => contact.IsPrimary);

        if (primaryEmailContact) {
            emailContact = primaryEmailContact.Locator || '';
        }

        if (!emailContact) {
            emailContact = allEmailPhoneContacts[0].Locator || '';
        }
    }

    return [phoneContact, emailContact];
};

export default HeiStoreContact;
